import { Checkbox } from "@/components/ui/checkbox";
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface CheckboxFieldProps {
  name: string;
  label?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
}
export default function CheckboxField({
  name,
  label,
  disabled,
  className,
}: CheckboxFieldProps) {
  return (
    <FormField
      name={name}
      render={(data) => (
        <FormItem className={cn("flex items-center pt-6", className)}>
          <FormControl>
            <Label className="flex items-center font-normal">
              <Checkbox
                className="mr-2"
                checked={data.field.value}
                onCheckedChange={data.field.onChange}
                disabled={disabled}
                {...data.field}
              />
              {label}
            </Label>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
